import React from 'react'

export const IconAlert = (props = {}) => {
	const {size = 20, imgSize= 20, fill = "white"} = props
	return <>
		<svg xmlns="http://www.w3.org/2000/svg"
				 width={`${size}px`}
				 height={`${size}px`}
				 viewBox={`0 0 ${imgSize} ${imgSize}`}
				 fill="none"
		>
			<path
				d="M10.0007 0.666626L0.833984 16.5H19.1673M10.0007 3.99996L16.2757 14.8333H3.72565M9.16732 7.33329V10.6666H10.834V7.33329M9.16732 12.3333V14H10.834V12.3333"
				fill={fill}
			/>
		</svg>
	</>
}
